// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/logo/logout_photo_container.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/logo/login_photo_container.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/images/logo/login_away_photo_container.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-marker {
  position: static;
  width: 58px;
  height: 58px;
  background-repeat: no-repeat;
  background-size: contain;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.MarkOut {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.MarkIn {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.MarkAway {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.custom-marker img {
  height: 40px;
  border-radius: 50%;
  width: 40px;
}`, "",{"version":3,"sources":["webpack://./src/gis/src/components/CustomMarkerImage.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mDAAA;AACF;;AAEA;EACE,mDAAA;AACF;;AAEA;EACE,mDAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;AACF","sourcesContent":[".custom-marker {\n  position: static;\n  width: 58px;\n  height: 58px;\n  background-repeat: no-repeat;\n  background-size: contain;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.MarkOut {\n  background: url(\"../assets//images/logo/logout_photo_container.svg\");\n}\n\n.MarkIn {\n  background: url(\"../assets//images/logo/login_photo_container.svg\");\n}\n\n.MarkAway {\n  background: url(\"../assets//images/logo/login_away_photo_container.svg\");\n}\n\n.custom-marker img {\n  height: 40px;\n  border-radius: 50%;\n  width: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
